import {
  DRAFT_CONTAINER,
  IPM_CONTAINER,
  PRE_IPM_CONTAINER,
  RELEVANT_STORIES_CONTAINER,
} from '@/constants/CONTAINER_NAMES.ts'
import { CONTAINER_PREFIX, TEMPORARY_ID_PREFIX } from '@/constants/PREFIX.ts'
import { getNow } from '@/utils/date.ts'

export const isTemporaryId = (id: string) => id.startsWith(TEMPORARY_ID_PREFIX)
export const getRandomKey = () => getNow().toString()
export const getTemporaryId = () => `${TEMPORARY_ID_PREFIX}${getRandomKey()}`
export const isEntityUpdate = (entity: Blocker | StoryComment | Task | Label): boolean =>
  !isTemporaryId(entity.id) || (isTemporaryId(entity.id) && !!entity.__typename)

export const isGroup = (id: string) => id.startsWith(CONTAINER_PREFIX)
export const getGroupNameFromKey = (key: string): { group: StoryGroup; subgroup: StorySubgroup | null } => {
  switch (key) {
    case RELEVANT_STORIES_CONTAINER:
      return { group: 'scheduled', subgroup: null }
    case IPM_CONTAINER:
      return { group: 'unscheduled', subgroup: 'IPM' }
    case PRE_IPM_CONTAINER:
      return { group: 'unscheduled', subgroup: 'PRE_IPM' }
    case DRAFT_CONTAINER:
      return { group: 'unscheduled', subgroup: 'DRAFT' }
    default:
      throw new Error(`Invalid key: ${key}`)
  }
}
